var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeballs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 307.09 382.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #4d4d4d;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #b0b0b0;\n        stroke: #b0b0b0;\n      }\n\n      .cls-3 {\n        fill: #e8e8e8;\n        stroke: #e8e8e8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye_Fill",
    "data-name": "Eye Fill"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "98.99 98.51 99.65 137.42 206.56 132.28 205.02 88.8 111.01 88.28 98.99 98.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.95,113.65c-.51,2.55.73,7.74,6.56,7.52,2.28-.09,6.51-2,6.51-6.38,0-4.69-3.78-6.42-6.51-6.6-2.19-.15-5.83,1.82-6.56,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.14,113.65c.51,2.55-.73,7.74-6.56,7.52-2.28-.09-6.51-2-6.51-6.38,0-4.69,3.78-6.42,6.51-6.6,2.19-.15,5.83,1.82,6.56,5.47Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.95,113.65c-.51,2.55.73,7.74,6.56,7.52,2.28-.09,6.51-2,6.51-6.38,0-4.69-3.78-6.42-6.51-6.6-2.19-.15-5.83,1.82-6.56,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.14,113.65c.51,2.55-.73,7.74-6.56,7.52-2.28-.09-6.51-2-6.51-6.38,0-4.69,3.78-6.42,6.51-6.6,2.19-.15,5.83,1.82,6.56,5.47Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeballs);
export default __webpack_public_path__ + "static/media/eyeballs.3b0367ce1d5a9329b7504d56dd18545b.svg";
export { ForwardRef as ReactComponent };